import { styled } from "@mui/material";
import { useTranslation } from "react-i18next";
import Typography from "components/Typography";

const NoResultsRoot = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: theme.spacing(0.5),
  padding: theme.spacing(1, 0),
  minHeight: theme.spacing(18),
}));

const NoResultsTitle = styled(Typography)(({ theme }) => ({
  fontWeight: theme.typography.fontWeightMedium,
  textAlign: "center",
  color: theme.palette.primary.main,
}));

const NoResultsDescription = styled(Typography)(({ theme }) => ({
  textAlign: "center",
  color: theme.palette.text.primary,
}));

export function ProfilingChartNoResults() {
  const { t } = useTranslation();
  return (
    <NoResultsRoot>
      <NoResultsTitle>{t("global.no_results_found_text")}</NoResultsTitle>
      <NoResultsDescription variant="TextXS">
        {t("athlete_profile.only_velocity_or_power_profiling_exercises")}
      </NoResultsDescription>
    </NoResultsRoot>
  );
}

export function OneRepMaxChartNoResults() {
  const { t } = useTranslation();
  return (
    <NoResultsRoot>
      <NoResultsTitle>{t("global.no_results_found_text")}</NoResultsTitle>
      <NoResultsDescription variant="TextXS">{t("athlete_profile.only_1rm_exercises")}</NoResultsDescription>
    </NoResultsRoot>
  );
}
